// src/components/Product/ProductCard/SizeSelector.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const SizeSelector = ({ 
  availableSizes, 
  selectedSize, 
  onSizeChange 
}) => {
  if (availableSizes.length === 0) return null;

  return (
    <Box sx={{ mb: 0, width: '100%' }}>
      <Typography 
        variant="subtitle1" 
        sx={{ 
          mb: 1,
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'right'
        }}
      >
        المقاس:
      </Typography>
      <Box sx={{ 
        display: 'flex', 
        gap: 1.5, 
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        width: '100%',
        mt: 1
      }}>
        {availableSizes.map(sizeItem => (
          <Button 
            key={sizeItem.id}
            variant={selectedSize === sizeItem.size ? 'contained' : 'outlined'} 
            onClick={() => onSizeChange(sizeItem.size)}
            disabled={sizeItem.stock < 1}
            sx={{
              minWidth: 60,
              height: 48,
              borderRadius: 2,
              fontWeight: 'bold',
              ...(selectedSize === sizeItem.size && {
                backgroundColor: '#0f3662',
                '&:hover': { backgroundColor: '#0f3662' }
              }),
              ...(selectedSize !== sizeItem.size && {
                borderColor: '#0f3662',
                color: '#0f3662',
                '&:hover': {
                  borderColor: '#0f3662',
                  backgroundColor: 'rgba(15, 54, 98, 0.04)'
                }
              })
            }}
          >
            {sizeItem.size}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default SizeSelector;
